import axiosInstance from "@/utils/axiosInstance";
import Buildings from "@/views/front-office/buildings/Buildings.vue";
import store from "@/store";

const baseUrl = `api/buildings`;

const state = {};

const getters = {};

const mutations = {};

const actions = {
  getBuildingById({ commit }, payload: { buildingId: number }) {
    return axiosInstance.get(`${baseUrl}/${payload.buildingId}`, {
      params: {},
    }).then((data) => data.data);
  },
  getAddressesRegistrationNumber({ commit }, payload: { registrationNumber: string}) {
    return axiosInstance.get(`${baseUrl}/registration-number`, {
      params: {
        registrationNumber : payload.registrationNumber,
      },
    }).then((data) => {
      return data.data;
    });
  },
  getLinkedKeysByBuildingId({ commit }, payload: { buildingId: number, query: object }) {
    return axiosInstance.get(`${baseUrl}/${payload.buildingId}/keys`, {
      params: payload.query,
    }).then((data) => data.data);
  },
  getKeyGroupsByBuildingId({ commit }, payload: { buildingId: number }) {
    return axiosInstance.get(`${baseUrl}/${payload.buildingId}/key-groups`, {
      params: {},
    }).then((data) => data.data);
  },
  getObjectsGroupsByBuildingId({ commit }, payload: { buildingId: number }) {
    return axiosInstance.get(`${baseUrl}/${payload.buildingId}/objects-groups`, {
      params: {},
    }).then((data) => data.data);
  },
  getNonTransferablesByBuildingId({ commit }, payload: { buildingId: number }) {
    return axiosInstance.get(`${baseUrl}/${payload.buildingId}/non-transferables`, {
      params: {},
    }).then((data) => data.data);
  },
  createNonTransferable({ commit }, payload: { buildingId: number, nonTransferableData: any }) {
    return axiosInstance.post(`${baseUrl}/${payload.buildingId}/non-transferables`, payload.nonTransferableData)
      .then((data) => data.data);
  },
  getOrdersByBuildingId({ commit }, payload: { buildingId: number, pagination: any }) {
    return axiosInstance.get(`${baseUrl}/${payload.buildingId}/orders`, {
      params: {
        page: payload.pagination?.page,
        itemsPerPage: payload.pagination?.itemsPerPage,
        sortBy: payload.pagination?.sortBy,
        sortDesc: payload.pagination?.sortDesc,
      },
    }).then((data) => data.data);
  },
  createOrder({ commit }, payload: { buildingId: number, orderData: any }) {
    return axiosInstance.post(`${baseUrl}/${payload.buildingId}/orders`, payload.orderData)
      .then((data) => data.data);
  },
  getSepteoGroupByBuildingId({ commit }, payload: { buildingId: number }) {
    return axiosInstance.get(`${baseUrl}/${payload.buildingId}/septeo-group`)
      .then((data) => data.data);
  },
  getBoxes({ commit }, payload: {
    buildingId: number,
    search: string | undefined,
    onlyConnected: boolean,
    onlyNotConnected: boolean,
    page: number,
    itemsPerPage: number,
  }) {
    return axiosInstance.get(`${baseUrl}/${payload.buildingId}/boxes`, {
      params: {
        search: payload.search,
        onlyConnected: payload.onlyConnected,
        onlyNotConnected: payload.onlyNotConnected,
        page: payload.page,
        itemsPerPage: payload.itemsPerPage,
      },
    })
      .then((data) => data.data);
  },
  getBoxesExtended({ commit }, payload: {
    buildingId: number, search: string | undefined, onlyConnected: boolean, onlyNotConnected: boolean,
  }) {
    return axiosInstance.get(`${baseUrl}/${payload.buildingId}/boxes-extended`,
      {params : {
          search : payload.search,
          onlyConnected : payload.onlyConnected,
          onlyNotConnected : payload.onlyNotConnected,
        },
      })
      .then((data) => data.data);
  },
  getAvailableLocations({commit}, payload: {buildingId: number}) {
    return axiosInstance.get(`${baseUrl}/${payload.buildingId}/locations/available`)
      .then((data) => data.data);
  },
  createBuilding({ commit }, payload: { companyId: number, building: object }) {
    return axiosInstance.post(`${baseUrl}`, {
      building: payload.building,
      companyId: payload.companyId,
    }).then((data) => data.data);
  },
  editBuilding({ commit }, payload: { buildingId: number, buildingData: object }) {
    return axiosInstance.put(`${baseUrl}/${payload.buildingId}`, payload.buildingData)
      .then((data) => data.data);
  },
  importBuildings({ commit }, payload: {buildings: object, importType: string, companyId: number}) {
    return axiosInstance.post(`${baseUrl}/import`, {
      buildings: payload.buildings,
      companyId: payload.companyId,
    }).then((data) => data.data);
  },
  addBox({commit}, payload: {buildingId: number, box: object}) {
    return axiosInstance.post(`${baseUrl}/${payload.buildingId}/boxes`, {box: payload.box})
      .then((data) => data.data);
  },
  addBoxes({commit}, payload: {buildingId: number, boxes: []}) {
    return axiosInstance.post(`${baseUrl}/${payload.buildingId}/boxes/bulk`, {boxes : payload.boxes})
      .then((data) => data.data);
  },
  getConnectedBoxes({commit}, payload: {id: number}) {
    return axiosInstance.get(`${baseUrl}/${payload.id}/boxes-extended`, {params: {
        onlyConnected: true,
        allLocations: true,
      }}).then((data) => data.data);
  },
  getOnboardingStatusByBuildingId({commit}, payload: {
    buildingId: number,
  }): Promise<any> {
    return axiosInstance.get(`${baseUrl}/${payload.buildingId}/onboarding-status`, {
    }).then((data) => data.data);
  },
  associateUrmetByBuildingId({commit}, payload: {
    buildingId: number,
    badgeNumber: string,
    mandate: File,
  }): Promise<any> {
    const formData = new FormData();
    formData.append("badgeNumber", payload.badgeNumber);
    formData.append("file", payload.mandate);
    return axiosInstance.post(`${baseUrl}/${payload.buildingId}/associate-urmet`,
      formData,
    ).then((data) => data.data);
  },
};

export default {
  namespaced: true, state, getters, actions, mutations,
};
